module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('selector'), _vm._v(" "), _c('builder'), _vm._v(" "), _c('p', {
    staticClass: "contact",
    domProps: {
      "innerHTML": _vm._s(_vm.footer)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('datenschutzerklaerung'), _vm._v(" "), _c('badge')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "contact"
  }, [_c('strong', {
    staticStyle: {
      "color": "#AAAAAA"
    }
  }, [_vm._v("Hinweis im allgemein öffentlichen Interesse:")]), _c('br'), _vm._v("\n    Da es immer wieder nicht verstanden wird: Dies ist ein satirisches Projekt welches von keinerlei Parteien oder\n    sonstigen politischen Organisationen unterstützt wird.\n    Dieses Projekt hat keine politische Agenda und ist nicht für die usergenerierten Inhalte die daraus hervorgehen verantwortlich.\n    Sollten dargestellte Personen oder anderweitig in die Plakate involvierte Personen Probleme mit dieser Art der Repräsentation haben, möge eine E-Mail an "), _c('a', {
    attrs: {
      "href": "mailto:gregor@vostrak.com"
    }
  }, [_vm._v("gregor@vostrak.com")]), _vm._v(" erfolgen.\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 230
// module chunks = 1